import axios, {
    AxiosResponse
} from 'axios';
import {
    WrappedResponse
} from './models'
export default class UsersApiService {
    public static directoryUsers(query: string): Promise<AxiosResponse<WrappedResponse<{ displayName: string; email: string }[]>>> {
        return axios.get('/api/Users/DirectoryUsers', { params: { query } });
    }

    public static adminRoles(): Promise<AxiosResponse<WrappedResponse<{ email: string }[]>>> {
        return axios.get('/api/Users/AdminRoles');
    }

    public static setAdminRole(email: string, isAdmin: boolean): Promise<AxiosResponse<WrappedResponse<unknown>>> {
        return axios.put('/api/Users/AdminRoles', { email, isAdmin });
    }

    public static isAdmin(clientConfig ? : {
        ignoreError ? : boolean
    }): Promise < AxiosResponse < WrappedResponse < boolean >>> {
        return axios.request( < any > {
            url: `/api/Users/IsAdmin`,
            method: 'get',
            clientConfig: clientConfig
        })
    }
}
